import { useMutation } from '@apollo/client';
import { Box, CircularProgress } from '@mui/material';
import { NavigationBar } from 'modules/NavigationModule/components/NavigationBar';
import { Suspense, useEffect, lazy } from 'react';
import { Routes, Route, BrowserRouter } from 'react-router-dom';
import communityForumServices from 'services/community.services';
import styled from 'styled-components';

import { colors } from 'constants/colors';

import { useAppDispatch } from './store/hooks';
import { setUser } from './store/user/actions';

const UnregisteredUserView = lazy(() => import('./modules/UnregisteredUserModule/views/UnregisteredUserView'));
const CommunityView = lazy(() => import('./modules/CommunityModule/views/CommunityView'));
const HomePageView = lazy(() => import('./modules/HomeModule/views/HomePageView'));
const PostView = lazy(() => import('modules/PostModule/views/PostView'));

const LoaderBox = styled(Box)`
  display: flex;
  align-items: center;
  height: 100vh;
  justify-content: center;
`;

function App() {
  const dispatch = useAppDispatch();
  const [syncUser, { error, loading }] = useMutation(communityForumServices.SYNC_USER);

  useEffect(() => {
    syncUser().then(user => {
      if (user.data?.syncUser) {
        dispatch(setUser(user.data.syncUser));
      }
    });
  }, [syncUser]);

  if (loading)
    return (
      <LoaderBox>
        <CircularProgress />
      </LoaderBox>
    );

  return (
    <div className="App">
      <Suspense fallback={<CircularProgress sx={{ color: colors.darkRed[100] }} />}>
        <BrowserRouter>
          <NavigationBar isUserRegistered={!error} />
          {error ? (
            <UnregisteredUserView />
          ) : (
            <Routes>
              <Route path="/" element={<HomePageView />} />
              <Route path="/community/:url" element={<CommunityView />} />
              <Route path="/community/:url/post/:postId" element={<PostView />} />
            </Routes>
          )}
        </BrowserRouter>
      </Suspense>
    </div>
  );
}

export default App;
